function aico_get_data(data) {
  switch (data) {
    case "Authorization":
      return "Bearer u0vctUUjIlqnvRh1DMc1N8Mr7Uy1eme65AvP9IwKc21e60e9";
      break;
    case "API_URL":
      return "https://app.aico.swiss/19856/api/v1/";
      break;
  }
}

var API_URL = aico_get_data("API_URL");
var Authorization = aico_get_data("Authorization");

function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

var currentLang = document.documentElement.lang || "en";
